import { Fragment, useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../utils/auth";
import { sdkWrapperURL } from "../utils/api-url-list";
import LoadingScreen from "../components/LoadingScreen";

const AuthBypass = () => {
  const { login } = useAuth();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const referFor = searchParams.get("referFor");
        const baseInfo = searchParams.get("baseInfo");
        const resp = await fetch(sdkWrapperURL("/auth/direct-login-user"), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ payload: baseInfo, "X-CPR-ID": referFor }),
        });
        const resp_json = await resp.json();
        if (resp_json?.statusCode?.toString().startsWith("2")) {
          localStorage.clear();
          await login({
            id_token: resp_json.user.id_token,
            refresh_token: resp_json.user.refresh_token,
            referrer_info: {
              client: referFor,
              path: resp_json.user.redirect_path,
            },
          });
        } else
          throw new Error(resp_json?.message ?? "Failed to get Login details.");
      } catch (err) {
        console.error(err);
        if (err instanceof Error) setError(err.message);
        else if (typeof err === "string") setError(err);
        else setError("Failed to get Login details.");
      }
    })();
  }, [login, searchParams]);

  return (
    <>
      <LoadingScreen />
      <Transition show={error.length > 0} as={Fragment}>
        <Dialog as={Fragment} onClose={() => {}}>
          <Transition.Child
            className="fixed inset-0 bg-black/70 flex items-center justify-center"
            enter="duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="duration-300 delay-150"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Transition.Child
              as={Fragment}
              enter="delay-150 duration-200"
              enterFrom="opacity-0 scale-50"
              enterTo="opacity-100 scale-100"
              leave="duration-100"
              leaveFrom="opacity-50 scale-50"
              leaveTo="opacity-0 scale-0"
            >
              <Dialog.Panel className="w-4/5 bg-white rounded-2xl p-6 flex flex-col items-center text-center">
                <Dialog.Title className="mt-2 text-primary text-sm">
                  {error}
                </Dialog.Title>
                <button
                  className="mt-4 px-4 py-2 rounded-full outline-none bg-gradient text-white text-xs font-medium"
                  type="button"
                  onClick={() => {
                    window.close();
                  }}
                >
                  Close
                </button>
              </Dialog.Panel>
            </Transition.Child>
          </Transition.Child>
        </Dialog>
      </Transition>
    </>
  );
};

export default AuthBypass;
